/** Canonical path prefixes used by all target import-path builders. */
export const AB_RULES = '.agentsmesh/rules';
export const AB_COMMANDS = '.agentsmesh/commands';
export const AB_AGENTS = '.agentsmesh/agents';
